import { FC, useContext } from "react"
// ** Gatsby
import { graphql, useStaticQuery } from "gatsby"
import Container from "../../components/Container"
import Box from "../../components/Box"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import Text from "../../components/Text"
import Heading from "../../components/Heading"
import PageContext from "../../contexts/PageContext"
type heroDataType = {
  heading: string
  tagline: string
  image: IGatsbyImageData
}
interface Props {
  lang: "en" | "fr"
}
const SectionBlogHero: FC<Props> = () => {
  const data = useStaticQuery(graphql`
    query {
      allSanityPage(filter: { title: { eq: "Blog-Page" } }) {
        nodes {
          slug {
            current
          }
          i18n_lang
          sections {
            ... on SanitySectionHero {
              id
              label
              Heading
              tagline
              imagePreview {
                asset {
                  gatsbyImageData(
                    placeholder: NONE
                    layout: CONSTRAINED
                    height: 400
                    formats: [WEBP, AUTO]
                  )
                }
              }
            }
          }
        }
      }
    }
  `)

  const page = useContext(PageContext)
  const currentBlog = data?.allSanityPage?.nodes?.find(
    (node: any) => node.i18n_lang === page.i18n_lang
  )
  const section = currentBlog.sections.find(
    (section: any) => section?.Heading && section
  )
  const heroData: heroDataType = {
    heading: section.Heading,
    tagline: section.tagline,
    image: section.imagePreview.asset.gatsbyImageData,
  }
  return (
    <Container
      className="flex flex-col w-full lg:flex-row-reverse gap-10 mt-10 md:mt-14"
      fullWidthOnMobile={false}
      constrainedToBreakPoint
    >
      <Box className="lg:flex-1">
        <GatsbyImage image={heroData.image} alt="career hero image" />
      </Box>
      <Box className="lg:basis-4/12 text-center lg:text-left">
        <Box className="w-full">
          <Heading className="text-blue-500 mt-6 lg:w-64">
            {heroData.heading}
          </Heading>
          <Text className="mt-4 lg:mt-8 lg:w-[270px]" variant="small">
            {heroData.tagline}
          </Text>
        </Box>
      </Box>
    </Container>
  )
}

export default SectionBlogHero
